import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Background from './Background';
import Button from '../Button';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wrapperHeight: 0,
    };
  }
  componentDidMount() {
    this.setHeight();
  }
  componentDidUpdate() {
    this.setHeight();
  }
  setHeight() {
    const modalWindowChildren = this.node.children[1].children;
    const headerHeight = modalWindowChildren[0].clientHeight;
    const footerHeight = modalWindowChildren.length > 2 ? modalWindowChildren[2].clientHeight : 0;

    const totalHeight = headerHeight + footerHeight;
    if (totalHeight !== this.state.wrapperHeight) {
      this.setState({ wrapperHeight: totalHeight });
    }
  }
  render() {
    return (
      <div ref={(node) => { this.node = node; }}>
        <Background onClick={this.props.closeMethod} />
        <ModalWindow className={this.props.className} height={this.props.height} width={this.props.width}>
          <Header>
            {this.props.showCloseButtons !== false &&
              <CloseButton onClick={this.props.closeMethod}><i className="glyphicon glyphicon-remove"></i></CloseButton>
            }
            <Title center={this.props.centralTitle}>{this.props.title}</Title>
            <SubTitle>{this.props.subtitle}</SubTitle>
          </Header>
          <ModalWrapper height={this.state.wrapperHeight}>
            <ModalContainer>
              {this.props.children}
            </ModalContainer>
          </ModalWrapper>
          {this.props.showCloseButtons !== false &&
            <Footer>
              <Button onClick={this.props.closeMethod}>Done</Button>
            </Footer>
          }
        </ModalWindow>
      </div>
    );
  }
}

export const ModalWindow = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: #fff;
  width: ${(props) => props.width || '80%'};
  height: ${(props) => props.height || '80%'};
  z-index: 999;
  padding: 30px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,.5);
  transform: translateY(-50%) translateX(-50%);
`;

const ModalWrapper = styled.div`
  height: calc(100% - ${(props) => props.height}px);
  overflow-x: hidden;
  overflow-y: auto;
`;

const ModalContainer = styled.div`
  min-height: 100%;
`;

const Header = styled.div`
  display: block;
  width: 100%;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.4;
  transition: opacity 0.5s;
  font-weight: bold;
  &:hover{
    opacity: 1;
  }
`;

const Title = styled.h2`
  ${(props) => props.center && 'text-align: center;'}
`;

const SubTitle = styled.p`
  font-size: 16px;
`;

const Footer = styled.div`
  position: absolute;
  display: block;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 20px;
  text-align: right;
  border-top: 1px solid #eeeeee;
  background-color: #ffffff;
`;

Modal.propTypes = {
  closeMethod: PropTypes.func,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.node,
  ]),
  className: PropTypes.string,
  showCloseButtons: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  centralTitle: PropTypes.bool,
};

export default Modal;



// WEBPACK FOOTER //
// ./app/components/Modal/index.js